export const LEASE = { title: "Lease", index: 3 };
export const RETAIL_NOTE = { title: "Retail Note", index: 4 };
export const CASH_SALE = { title: "Cash Sale", index: 0 };
export const CUSTOMER_AND_DEAL_INFO = {
  title: "Customer & Deal Information",
  index: 1,
};
export const COMPETITOR_INFO = {
  title: "Competitor Information",
  index: 2,
};
export const DLR_COST_MARGIN = { title: "Dealer Cost & Margin", index: 5 };
export const SPREAD_MARGIN_CALC = {
  title: "Spread & Margin Calculations",
  index: 7,
};
export const MACHINE_SPEC = {
  title: "Machine Specification",
  index: 6,
};
export const accordion = {
  CUSTOMER_AND_DEAL_INFO,
  COMPETITOR_INFO,
  DLR_COST_MARGIN,
  SPREAD_MARGIN_CALC,
  LEASE,
  RETAIL_NOTE,
  CASH_SALE,
  MACHINE_SPEC,
};

export const HOME = { activityName: "Home", displayIndex: 1 };
export const SIMULATE_USER = {
  activityName: "Simulate User",
  activityId: "A1341.2.16",
  displayIndex: 2,
};
export const EXIT_SIMULATE_USER = {
  activityName: "Exit Simulation",
  displayIndex: 3,
};
export const CREATE_TRANSACTION = {
  activityName: "Create Transaction",
  activityId: "A1341.2.1",
  displayIndex: 4,
};
export const SEARCH_TRANSACTION = {
  activityName: "Search Transaction",
  activityId: "A1341.2.13",
  displayIndex: 5,
};

export const CONFIRM_SUBMITTED_TRANSACTION = {
  activityName: "Confirm Transaction/Confirm Submitted Transaction",
  activityId: "A1341.2.5",
};

export const EXPORT_TRANSACTION = {
  activityName: "Export",
  activityId: "A1341.2.10",
};
export const DELETE_TRANSACTION = {
  activityName: "Delete Transaction",
  activityId: "A1341.2.8",
};
export const EDIT_TRANSACTION = {
  activityName: "Edit Transaction",
  activityId: "A1341.2.2",
};
export const SUBMIT_TRANSACTION = {
  activityName: "Submit Transaction",
  activityId: "A1341.2.4",
};

export const RETAIL_INSTALLMENT_RATE = 6.5;
export const MDP = 15000;
export const LEASE_RATE = 6;
export const DEERE_DISCOUNT = 0.0;
export const AMORTIZATION_FACTOR = 0.75;

export const TWO = 2;
export const THREE = 3;
export const SIX = 6;
export const FOUR = 4;
export const TWO_POINT_FIVE = 2.5;
export const FOUR_POINT_FIVE = 4.5;

export const SALES_PERSON_ROLE = "Sales Person";
export const SALES_MANAGER_ROLE = "Sales Manager";
export const DATA_ENTRY = "Data Entry";
export const DEERE_MANAGER = "Deere Manager";
export const DEERE_EMPLOYEE = "Deere Employee";

export const WON = "Won";
export const LOST = "Lost";

export const TXN_STATUS = {
  CONFIRMED: "CONFIRMED",
  DELETED: "DELETED",
  PENDING: "PENDING",
  SUBMITTED: "SUBMITTED",
};

export const TXN_SCOPE = {
  VIEW: "view",
  EDIT: "edit",
  CREATE: "Create",
};

export const BRAZIL_CNTRY_CODE = "BR";
export const CANADA_CNTRY_CODE = "CA";
export const SPANISH_COUNTRIES_CODE = [
  "EC",
  "UY",
  "MX",
  "ES",
  "VE",
  "NI",
  "SV",
  "CO",
  "CL",
  "LA",
  "CR",
  "DO",
  "AR",
  "BO",
  "GT",
  "PE",
  "PA",
  "HN",
  "PA",
  "HN",
  "PR",
  "PY",
];
export const PT_BR_LOCALE = "pt_BR";
export const EN_US_LOCALE = "en_US";
export const FR_CA_LOCALE = "fr_CA";
export const ES_ES_LOCALE = "es_ES";

export const USD_CURRENCY = "USD";
export const CAD_CURRENCY = "CAD";
export const AUD_CURRENCY = "AUD";
export const AUS_COUNTRY_CODE = "AU";
export const CAN_COUNTRY_CODE = "CA";

export const PERCENTAGE = "%";
